// Novel Carousel Video Addtocart Start
 // !function(){if(window&&window.Shopify){const a={add:"SCE:add",update:"SCE:update",change:"SCE:change",clear:"SCE:clear",mutate:"SCE:mutate"},c=["/cart/add","/cart/update","/cart/change","/cart/clear","/cart/add.js","/cart/update.js","/cart/change.js","/cart/clear.js"];if(window.fetch&&"function"==typeof window.fetch){const d=window.fetch;window.fetch=function(){const t=d.apply(this,arguments);return e(arguments[0])&&t.then(e=>{e.clone().json().then(t=>n(e.url,t))}),t}}if(window.XMLHttpRequest){const i=window.XMLHttpRequest.prototype.open;window.XMLHttpRequest.prototype.open=function(){const t=arguments[1];return this.addEventListener("load",function(){e(t)&&n(t,this.response)}),i.apply(this,arguments)}}function e(t){if(t)return t=t.split("/").pop(),c.includes("/cart/"+t)}function n(t,e){if("string"==typeof e)try{e=JSON.parse(e)}catch{}window.dispatchEvent(new CustomEvent(a.mutate,{detail:e}));t=!!(t=t)&&(t.includes("cart/add")?"add":t.includes("cart/update")?"update":t.includes("cart/change")?"change":!!t.includes("cart/clear")&&"clear");switch(t){case"add":window.dispatchEvent(new CustomEvent(a.add,{detail:e}));break;case"update":window.dispatchEvent(new CustomEvent(a.update,{detail:e}));break;case"change":window.dispatchEvent(new CustomEvent(a.change,{detail:e}));break;case"clear":window.dispatchEvent(new CustomEvent(a.clear,{detail:e}))}}}}();
 (function () {
    if (!window || !window.Shopify) return;
  
    const CartEvents = {
      add: "SCE:add",
      update: "SCE:update",
      change: "SCE:change",
      clear: "SCE:clear",
      mutate: "SCE:mutate",
    };
  
    const ShopifyCartURLs = [
      "/cart/add",
      "/cart/update",
      "/cart/change",
      "/cart/clear",
      "/cart/add.js",
      "/cart/update.js",
      "/cart/change.js",
      "/cart/clear.js",
    ];
  
    function isShopifyCartURL(url) {
      if (!url) return false;
      const path = url.split("/").pop();
      return ShopifyCartURLs.includes(`/cart/${path}`);
    }
  
    function updateType(url) {
      if (!url) return false;
      if (url.includes("cart/add")) {
        return "add";
      } else if (url.includes("cart/update")) {
        return "update";
      } else if (url.includes("cart/change")) {
        return "change";
      } else if (url.includes("cart/clear")) {
        return "clear";
      } else return false;
    }
  
    function dispatchEvent(url, detail) {
      if (typeof detail === "string") {
        try {
          detail = JSON.parse(detail);
        } catch {}
      }
  
      window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
      const type = updateType(url);
      switch (type) {
        case "add":
          window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
          break;
        case "update":
          window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
          break;
        case "change":
          window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
          break;
        case "clear":
          window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
          break;
        default:
          break;
      }
    }
  
    function XHROverride() {
      if (!window.XMLHttpRequest) return;
  
      const originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
          if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
          }
        });
        return originalOpen.apply(this, arguments);
      };
    }
  
    function fetchOverride() {
      if (!window.fetch || typeof window.fetch !== "function") return;
      const originalFetch = window.fetch;
      window.fetch = function () {
        const response = originalFetch.apply(this, arguments);
  
        if (isShopifyCartURL(arguments[0])) {
          response.then((res) => {
            res
              .clone()
              .json()
              .then((data) => dispatchEvent(res.url, data));
          });
        }
  
        return response;
      };
    }
  
    // fetchOverride();
    XHROverride();
  })();
   
   
   window.addEventListener('SCE:mutate', (event) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true  //this code is for prestige theme, is to refresh the cart
    }));
  })
  
  window.addEventListener('SCE:add', (event) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true  //this code is for prestige theme, is to refresh the cart
    }));
  })
  
  window.addEventListener('SCE:update', (event) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true  //this code is for prestige theme, is to refresh the cart
    }));
  })
  
  window.addEventListener('SCE:change', (event) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true  //this code is for prestige theme, is to refresh the cart
    }));
  })
  
  window.addEventListener('SCE:clear', (event) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true  //this code is for prestige theme, is to refresh the cart
    }));
  })
 // Novel Carousel Video Addtocart End